module.exports = __webpack_public_path__ + "img/jj2.c0397457.png";